@if (message().__supplyDropStart; as startData) {
<p class="content">
  Payload inbound! Complete the captcha for a chance to open a
  <span class="highlight clickable" (click)="openCaseSkinsModal()">{{ startData.caseName }}</span>,
  you can see the requirements on our
  <span class="highlight clickable" (click)="navigateToRewards()">Rewards</span> page.
</p>
}

@if (message().__supplyDropEnd; as endData) {
<p class="content supply-drop-end">
  <span class="highlight clickable" (click)="openUserProfile()">{{ endData.winner.name }}</span>
  has won <span><app-cost [cost]="endData.dropValue" [balanceType]="'skins'" [gap]="0" class="inline-cost" /></span>
  from the
  <span class="highlight clickable" (click)="openCaseSkinsModal()">{{ endData.caseName }}</span>
  against {{ endData.playerCount }} other players,
  winning ticket percentage was {{ endData.ticketPercentage | number:'1.2-2' }}%, each player had {{ endData.winChance }}% chance to win.
</p>
@if (endData.gameid) {
<button
  class="verify-button button rounded-4 h-22 padding-x-8 button--style-yellow"
  (click)="navigateToVerify()"
>
  Verify
</button>
}
}
